export default class RoomManager {

    constructor(scene) {
        this.scene = scene

        this.crumbs = scene.crumbs

        this.loadId = 0
        this.room = null
    }

    joinRoom(roomId, users, npcs = []) {
        const room = this.crumbs.rooms[roomId]
        
        if (!room) {
            console.error(`[RoomManager] Room ${roomId} not found in crumbs`)
            return
        }
        
        const { key, path } = room

        if (path.startsWith('../')) {
            this.loadScene(key, path.substring(3), { id: roomId, users, npcs })
        } else {
            this.loadScene(key, `rooms/${path}`, { id: roomId, users, npcs })
        }
    }

    joinIgloo(args) {
        const igloo = this.crumbs.igloos[args.type]
        
        if (!igloo) {
            console.error(`[RoomManager] Igloo ${args.type} not found in crumbs`)
            return
        }
        
        const { key, path } = igloo

        this.loadScene(key, `igloos/${path}`, { args })
    }

    joinGameRoom(gameId) {
        const game = this.crumbs.games[gameId]

        if (!game) {
            console.warn('[RoomManager] Unknown game', gameId)
            return
        }

        const { key, path } = game

        if (typeof path === 'string' && path.endsWith('.swf')) {
            this.addFlashGame(game)
            return
        }

        this.loadScene(key, `games/${path}`, { id: gameId })
    }

    async loadScene(key, path, data = {}) {
        this.removeCurrent()

        const loadId = ++this.loadId

        const sceneClass = await this.loadSceneClass(path)

        if (sceneClass && loadId === this.loadId) {
            this.addRoom(key, sceneClass, data)
        }
    }

    addRoom(key, scene, data) {
        // Check if scene with this key already exists and remove it
        if (this.scene.scene.get(key)) {
            // Scene already exists, removing first
            this.scene.scene.remove(key)
        }
        
        this.room = this.scene.scene.add(key, scene, true, data)
    }

    addFlashGame(game) {
        this.removeCurrent()

        this.scene.scene.run(this.scene.ruffle)

        this.scene.ruffle.bootGame(game)
    }

    removeCurrent() {
        this.removeRoom()
        this.removeGame()
    }

    removeRoom() {
        this.room?.stop()
        this.room = null
    }

    removeGame() {
        this.scene.ruffle.stop()
    }

    async loadSceneClass(path) {
        try {
            const sceneClass = (await import(
                /* webpackInclude: /\.js$/ */
                `@scenes/${path}`
            )).default

            return sceneClass

        } catch (error) {
            console.error(error)

            return null
        }
    }

}
